import React from 'react';
import { painPoints } from '../../data/content';
import { CtaButton } from '../CtaButton';
export function PainPoints() {
  return <section className="w-full bg-cream px-4 py-14 sm:px-6 sm:py-20" data-id="element-250" data-mp="1twgvaqob8894">
      <div className="mx-auto w-full max-w-4xl" data-id="element-251" data-mp="27mkaixorv1p2">
        <div className="mx-auto max-w-2xl text-center" data-id="element-252" data-mp="27oezqo72tfyy">
          <h2 className="font-display text-[26px] font-extrabold leading-tight text-ink sm:text-4xl" data-id="element-253" data-mp="22uj3pradi36f">
            If any of these situations sound familiar, this was created for you
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-[15px] leading-relaxed text-graphite/75 sm:text-base" data-id="element-254" data-mp="2ckc37tx8qrub">
            You have the knowledge. What you need is a clearer way to apply it
            when the patient is sitting in front of you.
          </p>
        </div>

        <ul className="mt-10 flex flex-col gap-3" data-id="element-255" data-mp="w6vny7ffk4os">
          {painPoints.map(point => <li key={point.text} className="flex gap-3.5 rounded-2xl bg-white p-4 shadow-card ring-1 ring-ink/[0.06] sm:gap-4 sm:p-5" data-id="element-256" data-mp="s5jxy0sn9hg2">
              <span aria-hidden="true" className="text-xl leading-none sm:text-2xl" data-id="element-257" data-mp="1n5qn905byhwc">
                {point.emoji}
              </span>
              <p className="text-[14px] leading-relaxed text-graphite/85 sm:text-[15px]" data-id="element-258" data-mp="1x4eoin93iidc">
                {point.text}
              </p>
            </li>)}
        </ul>

        <p className="mx-auto mt-8 max-w-xl text-center font-display text-lg font-bold leading-snug text-ink sm:text-xl" data-id="element-259" data-mp="26urc6oc7irnp">
          The good news? You no longer have to rely on memory or waste time
          searching through multiple sources.
        </p>

        <div className="mt-8 flex justify-center" data-id="element-260" data-mp="2kvk4r3iy7co6">
          <CtaButton label="I want to stop improvising during consultations" data-id="element-261" data-mp="2ku9071hoi0w0" />
        </div>
      </div>
    </section>;
}